'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '@@asyncApi';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/storage/asyncApiSymbol.js
// module id = 427
// module chunks = 0